import axios from 'axios';

const baseUrl = import.meta.env.VITE_API_BASE_URL;

// List with server-side pagination / search / filters / sorting.
// params: { page, pageSize, search, Status, Priority, Source, PropertyType, City,
//           favorite, sortBy, sortDir, includeDeleted }
export const fetchLeads = async (params = {}) => {
  const res = await axios.get(`${baseUrl}/leads`, { params });
  return res.data || { data: [], total: 0, page: 1, pageSize: 20, totalPages: 0 };
};

export const fetchLeadById = async (leadId) => {
  const res = await axios.get(`${baseUrl}/leads/${leadId}`);
  return res.data;
};

export const fetchLeadStats = async () => {
  const res = await axios.get(`${baseUrl}/leads/stats`);
  return res.data || {};
};

export const fetchPropertyTypes = async () => {
  const res = await axios.get(`${baseUrl}/leads/property-types`);
  return Array.isArray(res.data) ? res.data : [];
};

export const checkDuplicate = async (mobile, excludeId) => {
  const res = await axios.get(`${baseUrl}/leads/check-duplicate`, { params: { mobile, excludeId } });
  return res.data || { duplicate: false };
};

export const addLead = (values) => axios.post(`${baseUrl}/leads`, values);
export const updateLead = (leadId, values) => axios.put(`${baseUrl}/leads/${leadId}`, values);
export const patchLead = (leadId, values) => axios.patch(`${baseUrl}/leads/${leadId}`, values);
export const deleteLead = (leadId) => axios.delete(`${baseUrl}/leads/${leadId}`);
export const restoreLead = (leadId) => axios.post(`${baseUrl}/leads/${leadId}/restore`);
export const toggleFavorite = (leadId) => axios.post(`${baseUrl}/leads/${leadId}/favorite`);
export const convertLeadToClient = (leadId) => axios.post(`${baseUrl}/leads/${leadId}/convert`);
export const addLeadTimeline = (leadId, values) => axios.post(`${baseUrl}/leads/${leadId}/timeline`, values);
